// extracted by mini-css-extract-plugin
export default {"phone-number":"Phone_phone-number__A6mMy","phone-number-inherited-color":"Phone_phone-number-inherited-color__dAsiR","phone-number-mobile":"Phone_phone-number-mobile__BIGbT"};